import { Box, BoxProps } from '@chakra-ui/react';
import { DragEvent, DragEventHandler, ReactNode } from 'react';

import { createDraImagePreview, destroyImageGhostPreview } from './Folders.helper';

export type ImageDragDropWrapperProps = {
  children: ReactNode;
  onDragStart?: DragEventHandler<HTMLDivElement>;
  isDraggable?: boolean;
  wrapperContentProps?: BoxProps;
  // custom drag image
  dragImage?: JSX.Element;
  dragImageOffset?: { x: number; y: number };
};
export const ImageDragDropWrapper = ({
  children,
  dragImage,
  isDraggable = true,
  wrapperContentProps,
  onDragStart = () => {},
  dragImageOffset,
}: ImageDragDropWrapperProps) => {
  /**
   * Handler to create a preview and call onDragStart
   * @param e DragEvent
   */
  const handleDragStart = async (e: DragEvent<HTMLDivElement>) => {
    if (dragImage) createDraImagePreview(e, dragImage, dragImageOffset);

    onDragStart(e);
  };

  /**
   * remove preview from screen
   */
  const onDragEnd = () => {
    destroyImageGhostPreview();
  };

  return (
    <Box
      draggable={isDraggable}
      onDragStart={handleDragStart}
      onDragEnd={onDragEnd}
      overflow='hidden'
      userSelect='none'
      padding='2px'
      {...wrapperContentProps}
    >
      {children}
    </Box>
  );
};

ImageDragDropWrapper.displayName = 'ImageDragDropWrapper';
